export function ceilWithMinus(params: number) {
    if (params >= 0) return Math.ceil(params);
    else {
        return -Math.ceil(-params);
    }
    // else return "E=" + Math.abs(Math.round(params)
}